import { createClient } from '@supabase/supabase-js';

// Singleton Supabase client. Reads URL + publishable key from Vercel env vars
// (injected at build time, baked into the bundle — safe because publishable key
// is designed to be public).
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Don't throw at import time — let the component using it fail gracefully.
  // This also avoids breaking local dev if someone forgets to set the env vars.
  // eslint-disable-next-line no-console
  console.warn(
    'Supabase env vars missing. Set REACT_APP_SUPABASE_URL and ' +
      'REACT_APP_SUPABASE_ANON_KEY in your .env (local) and Vercel (prod).'
  );
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    // Persist session in localStorage so the user stays logged in between tabs
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // parse magic link hash on callback
  },
});
